export enum ModuleDefinitionTemplates {
  DEFAULT = "DEFAULT",
  CALL = "CALL",
  VISIT = "VISIT",
  MEETING = "MEETING",
  PRODUCT = "PRODUCT",
  NOTE = "NOTE",
  APPOINTMENT = "APPOINTMENT",
}
